import React, { useEffect } from 'react';

import './App.css';
import StartPage from './pages/start';
import LoginPage from './pages/login';
import SignupPage from "./pages/signup";
import GameplayPage from './pages/gameplay';
import SummaryPage from "./pages/summary"
import ConfirmationPage from "./pages/confirmation"
import NotFoundPage from './pages/404'

import { HashRouter as Router, Route, Routes, Navigate } from 'react-router-dom';

const PageIndex = Object.freeze({
  START: 0,
  LOGIN: 1,
  SIGNUP: 2,
  GAMEPLAY: 3,
  SUMMARY: 4,
  CONFIRMATION: 5
});


const GenPage = (pageindex) => {

  //fetch page content
  const fetchPage = (pageindex) => {
    console.log('pageindex',pageindex)
    switch (pageindex) {
      case PageIndex.START:
        return (<StartPage />);
      case PageIndex.LOGIN:
        return (<LoginPage />);
      case PageIndex.SIGNUP:
        return (<SignupPage />);
      case PageIndex.GAMEPLAY:
        return (<GameplayPage />);
      case PageIndex.SUMMARY:
        return (<SummaryPage />);
      case PageIndex.CONFIRMATION:
        return (<ConfirmationPage />);
      default:
        console.error("err: unknown page, cannot route");
        break;
    }
  };

  return (
    <div className="App">
      <main>
        {fetchPage(pageindex)}
      </main>
    </div>
  );

}


function App() {
  // NOTE: added for testing
  // localStorage.clear();

  // set the title here
  useEffect(() => {
    document.title = "WhoAmI"
  }, []);

  // route to different pages
  return (
    <Router>
      <Routes>
        <Route path="*" element={<NotFoundPage />} />
        <Route path="/" element={GenPage(PageIndex.START)} />
        <Route path="/login" element={GenPage(PageIndex.LOGIN)} />
        <Route path="/signup" element={GenPage(PageIndex.SIGNUP)} />
        <Route path="/gameplay" element={GenPage(PageIndex.GAMEPLAY)} />
        <Route path="/summary" element={GenPage(PageIndex.SUMMARY)} />
        <Route path="/confirmation/:confirmationToken" element={GenPage(PageIndex.CONFIRMATION)} />
      </Routes>
    </Router>
  );

}

export default App;
